exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".oyFFf0G6xoh1eXrsTskZT{display:flex;flex-direction:column;margin:20px;height:65vh}@media screen and (min-width: 1025px){.oyFFf0G6xoh1eXrsTskZT{margin:50px 150px}}\n", ""]);
// Exports
exports.locals = {
	"main": "oyFFf0G6xoh1eXrsTskZT"
};